import { render, staticRenderFns } from "./AtestoDados.vue?vue&type=template&id=48c28463"
import script from "./AtestoDados.vue?vue&type=script&lang=js"
export * from "./AtestoDados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports